import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { blogService, Blog } from "./../pages/publicservice/BlogsService";

const BlogSection: React.FC = () => {

  const [posts, setPosts] =
    useState<Blog[]>([]);

  useEffect(() => {
    loadBlogs();
  }, []);

  async function loadBlogs() {
    try {

      const data =
        await blogService.getAll();

      // show only published blogs
      const publishedBlogs =
        data.filter(
          x => x.status === "Published"
        );

      setPosts(
        publishedBlogs.slice(0, 3)
      );

    } catch (error) {
      console.log(error);
    }
  }

  function formatDate(date: string) {

    return new Date(date)
      .toLocaleDateString(
        "en-US",
        {
          month: "long",
          day: "numeric",
          year: "numeric"
        }
      );
  }

  return (
    <section className="space-extra-bottom">
      <div className="container">

        <div className="row justify-content-center">
          <div className="col-auto">
            <div className="title-area text-center">
              <span className="sec-subtitle">
                our news & blog
              </span>

              <h2 className="sec-title text-white">
                Latest News update
              </h2>

              <img
                src="/assets/img/shapes/title-shape-1.svg"
                alt=""
              />
            </div>
          </div>
        </div>

        <div className="row">

          {posts.map((post, i) => (

            <div
              key={post.blogID}
              className="col-lg-4 wow animate__fadeInUp"
              data-wow-delay={`${0.2 * (i + 1)}s`}
            >
              <div className="vs-blog blog-style2">

                <div className="blog-img">

                  <Link
                    to={`/BlogDetails/${post.blogSlug}`}
                  >
                    <img
                      className="img"
                      src={post.blogImage}
                      alt={post.blogTitle}
                    />
                  </Link>

                </div>

                <div className="blog-body">

                  <div className="blog-metas">

                    <span className="blog-meta">
                      {formatDate(
                        post.publishDate
                      )}
                    </span>

                    <span className="blog-meta">
                      {post.authorName}
                    </span>

                  </div>

                  <h3 className="blog-title">

                    <Link
                      to={`/BlogDetails/${post.blogSlug}`}
                    >
                      {post.blogTitle}
                    </Link>

                  </h3>

                  <span className="blog-divider2"></span>
                  <span className="blog-divider"></span>

                  <Link
                    to={`/BlogDetails/${post.blogSlug}`}
                    className="blog-link"
                  >
                    read more
                  </Link>

                </div>

              </div>
            </div>

          ))}

        </div>
      </div>
    </section>
  );
};

export default BlogSection;